import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-159" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-4xl" data-id="element-160" data-mp="3ksgwy4rr2bbc">
        <div className="text-center" data-id="element-161" data-mp="3fyvxs9ef7bak">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-162" data-mp="3fxuly2pkykrs">
            Recensioni verificate
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-163" data-mp="36ypokzpr8xh7">
            Cosa dicono le tue{' '}
            <span className="italic text-grape" data-id="element-164" data-mp="31yl6j5977uov">colleghe</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-165" data-mp="2x1bh3plt7j11">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-cream p-6" data-id="element-166" data-mp="2s3t5frgeqppc">
              <div className="text-sm text-tangerine" aria-label="5 stelle su 5" data-id="element-167" data-mp="q9u0roxsj6lm">
                <span aria-hidden="true" data-id="element-168" data-mp="h55aw37q1xxm">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-navy/85" data-id="element-169" data-mp="m5b3pmpq9qha">
                &laquo;{item.quote}&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-170" data-mp="c6ll1rq0c1zz">
                <p className="text-xs font-bold text-navy" data-id="element-171" data-mp="c7n0s9hyxco1">{item.name}</p>
                <p className="text-xs text-navy/45" data-id="element-172" data-mp="zw674jhgjfdh">{item.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}